import trackLink from "../../../../../../services/analytics/trackLink";
import { SORT_ITEMS_ACTION } from "../constants";
import {
  ADOBE_SAVED_ITEMS_REFINEMENT_EVENT_KEY,
  ADOBE_SAVED_ITEM_ACTION_KEY,
  ADOBE_SORT_BY_KEY
} from "../../../../../../services/analytics/constants";
import { setSort } from "../setSort";

export const setSortIntent = (state, { payload: { sort, sortOrder } }) => {
  const newState = {
    ...setSort(state, { payload: { sort, sortOrder } }),
    trackLink: {
      savedItemAction: SORT_ITEMS_ACTION,
      vars: [ADOBE_SORT_BY_KEY, ADOBE_SAVED_ITEM_ACTION_KEY],
      events: [ADOBE_SAVED_ITEMS_REFINEMENT_EVENT_KEY]
    }
  };

  trackLink({ state: newState });

  return newState;
};
